module.exports = __webpack_public_path__ + "img/hongbao.5c3a4035.png";